/**
 * JSR
 * jquery_start.js
 * Startovací funkce pro JQuery
 *
 * @package zaklad
 *
 * @author Josef Šmíd <josef@skit.cz>
 * @copyright (c) 2007-2026 Josef Šmíd
 * @version 2.6.0
 */

/*document.addEventListener('simpleLightbox-ready', function() {
  if( $('.fotogalerie').length > 0 )
  {
    $('.fotogalerie').simpleLightbox();
  }
});*/

/**
 * Nastaví cookie (náhrada za $.cookie z jQuery Cookie pluginu).
 *
 * @param {string} jmeno Název cookie.
 * @param {string} hodnota Hodnota cookie.
 * @param {number} dny Počet dní platnosti.
 * @returns {void}
 */
function nastavCookie(jmeno, hodnota, dny)
{
  var datum = new Date();
  datum.setTime(datum.getTime() + (dny * 86400000));
  document.cookie = jmeno + '=' + encodeURIComponent(hodnota) + '; expires=' + datum.toUTCString() + '; path=/';
}

/**
 * Zobrazí plovoucí hlášku nahoře na stránce (náhrada bootstrapGrowl bez závislosti na Bootstrap JS).
 *
 * @param {string} text Text hlášky.
 * @param {string} typ Typ hlášky (success|danger|info).
 * @returns {void}
 */
function zobrazHlasku(text, typ)
{
  var $hlaska = $('<div class="bootstrap-growl alert"><a class="close" href="#">&times;</a></div>')
    .addClass('alert-' + typ)
    .append(text)
    .css({ position: 'fixed', width: '450px', 'z-index': 99999, display: 'none' });

  var offset = 20;
  $('.bootstrap-growl').each(function()
  {
    offset = Math.max(offset, parseInt($(this).css('top'), 10) + $(this).outerHeight() + 10);
  });
  $hlaska.css('top', offset + 'px');

  $('body').append($hlaska);
  $hlaska.css({ left: '50%', 'margin-left': -($hlaska.outerWidth() / 2) + 'px' });

  var odeber = function() { $hlaska.fadeOut(function() { $hlaska.remove(); }); };
  $hlaska.find('a.close').on('click', function(e) { e.preventDefault(); odeber(); });
  $hlaska.fadeIn();
  setTimeout(odeber, 4000);
}

/**
 * Naformátuje cenu pro výpis na frontendu stejně jako server (cena::vypis) – zaokrouhlení
 * dle #zaokrouhlit, oddělení tisíců nezlomitelnou mezerou, desetinná čárka a symboly měny
 * z #mena_pred a #mena_za.
 *
 * @param {number} cena Cena k naformátování.
 * @returns {string}
 */
function formatujCenu(cena)
{
  var zaokr = parseInt($('#zaokrouhlit').val(), 10);
  if (isNaN(zaokr)) zaokr = 0;

  var cislo = Number(cena).toFixed(zaokr).replace('.', ',');
  cislo = cislo.replace(/\B(?=(\d{3})+(?!\d))/g, '&nbsp;');

  return (($('#mena_pred').val() || '') + cislo + ($('#mena_za').val() || '')).replace(/ /g, '&nbsp;');
}

$(document).ready(function()
{ 
  var root = $( 'input#js_root' ).val();

  //otevření odkazu do nového okna
  $('a.noveokno').click(function() { window.open( $(this).attr('href'), '_blank' ); return false; });
 
  //NENÍ POTŘEBA - nahrazeno pravidlem a:has(> img) v scss/_basic.scss (platí i pro dynamicky vložený obsah); ponecháno jen jako záloha pro starší prohlížeče bez :has()
  $('a > img').parent().not('.varianta-radek').css({'border-bottom' : 'none'});
  
  //nastavení cookie při kliknutí na zavírací křížek
  /* nahrazeno vlastní funkcí nastavCookie(), aby se na frontendu nemusel načítat jQuery Cookie plugin
  $("a#cookies_accept").click( function() { $.cookie( "jsr_cookies", "1", { expires: 180, path: "/" }); $("div#cookies").fadeOut(); return false; });
  $( ".info_close" ).click( function() { $.cookie( "jsr_info_vrsek_close", "1", { expires: 7, path: "/" }); $(".info_vrsek").fadeOut(); return false; });
  $( "#mailing_open_dialog_close" ).click( function() { $.cookie( "jsr_mailing_open_dialog_close", "1", { expires: 7, path: "/" }); $("#mailing_open_dialog").fadeOut(); return false; });
  */
  $("a#cookies_accept").click( function() { nastavCookie( "jsr_cookies", "1", 180 ); $("div#cookies").fadeOut(); return false; });
  $( ".info_close" ).click( function() { nastavCookie( "jsr_info_vrsek_close", "1", 7 ); $(".info_vrsek").fadeOut(); return false; });
  $( "#mailing_open_dialog_close" ).click( function() { nastavCookie( "jsr_mailing_open_dialog_close", "1", 7 ); $("#mailing_open_dialog").fadeOut(); return false; });
  
  //výpis chyb
  if ($('input#js_chyba').val() !== '')
  {
    var chyby = $('input#js_chyba').val().split(';');
    for (var i = 0; i < chyby.length; i++)
    {
      if (chyby[i] !== '')
      {
        /* nahrazeno vlastní funkcí zobrazHlasku(), aby se nemusel načítat Bootstrap JS jen kvůli hláškám
        $.bootstrapGrowl(chyby[i], {
          ele: 'body', // which element to append to
          type: (i == 0 ? 'success' : 'danger'), // (null, 'info', 'danger', 'success')
          offset: {from: 'top', amount: 20}, // 'top', or 'bottom'
          align: 'center', // ('left', 'right', or 'center')
          width: 450, // (integer, or 'auto')
          stackup_spacing: 10 // spacing between consecutively stacked growls.
        });
        */
        zobrazHlasku(chyby[i], (i == 0 ? 'success' : 'danger'));
      }
    }
  }
  
  //slider v záhlaví webu - reklamní lišta
  (function () {

    const $slider = $("#demo .slider");
    const $items = $slider.find("p");
    let current = 0;
    let interval;

    function recalcHeight() {
      let max = 0;
      $items.each(function () {
        const $p = $(this);
        $p.show();
        const h = $p.outerHeight();
        if (h > max)
          max = h;
        $p.hide();
      });
      $slider.height(max);
    }

    function next() {
      $items.eq(current).hide();
      current = (current + 1) % $items.length;
      $items.eq(current).show();
    }

    function init() {
      clearInterval(interval);
      recalcHeight();
      $items.hide();
      current = 0;
      $items.eq(0).show();
      interval = setInterval(next, 5000);
    }

    init();
    $(window).on("resize", init);

  })(); // IIFE = vše uzavřeno, žádné globální proměnné

  //na telefonu skrývá chat a reklamu vlevo
  (function () {
      // Prvně zkontrolujeme, jestli je widget načtený
      var checkWidgetLoaded = setInterval(function () {
        if ($('#smartsupp-widget-container div').length) {
          clearInterval(checkWidgetLoaded); // Zastaví kontrolu po načtení widgetu

          // Když je widget načtený, přidáme pozorování na scroll
          $(window).scroll(function () {
            if( window.matchMedia('(max-width: 992px)').matches )
            {
              var scrollPosition = $(window).scrollTop(); // Získáme aktuální pozici scrollu

              if (scrollPosition > 50) {  // Pokud je stránka scrollována víc než 100px dolů
                $('#smartsupp-widget-container div').css('display', 'none'); // Přidáme border 
              } else {
                $('#smartsupp-widget-container div').css('display', 'block'); // Odebereme border, když je zpět nahoře 
              }
            }
          });
        }
      }, 500); // Kontroluje každých 500ms, zda je widget na stránce
      
      $(window).scroll(function () {
        if( window.matchMedia('(max-width: 992px)').matches )
        {
          var scrollPosition = $(window).scrollTop(); // Získáme aktuální pozici scrollu

          if (scrollPosition > 50) {  // Pokud je stránka scrollována víc než 100px dolů
            $('#mailing_open_dialog').addClass( 'is-hidden' ); // Přidáme border 
          } else {
            $('#mailing_open_dialog').removeClass( 'is-hidden' ); // Odebereme border, když je zpět nahoře 
          }
        }
      });
  })();
  
  (function () {
    const globalVideoObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const video = entry.target;
          const source = video.querySelector('source[data-src]');
          if (source) {
            source.src = source.dataset.src;
            delete source.dataset.src; // označí, že už je vyřízeno
            video.load();
            video.addEventListener('loadeddata', () => {
              video.dispatchEvent(new CustomEvent('video-source-ready'));
            }, {once: true});
          } else {
            // zdroj už byl nastaven dřív (např. video bez data-src) - rovnou ready
            video.dispatchEvent(new CustomEvent('video-source-ready'));
          }
          globalVideoObserver.unobserve(video);
        }
      });
    }, {rootMargin: '400px'});

    window.globalVideoObserver = globalVideoObserver;//zpřístupněno, aby šlo přihlásit i videa vložená později (např. po AJAX výměně obsahu)
    document.querySelectorAll('video').forEach(video => globalVideoObserver.observe(video));
  })();

//  $('#zahlavi_prave').cycle({
//    fx: 'fade',
//    speed:   1500,
//    timeout: 4000,
//    pause:   0
//    });

    $('.dropdown li.head').hover(
    function() { $('#menu_podkat', this).css('display', 'block'); },
    function() { $('#menu_podkat', this).css('display', 'none');
    });
    $('.dropdown li.head').hover(
        function() { $('.menu_podkat_new', this).css('display', 'block'); },
        function() { $('.menu_podkat_new', this).css('display', 'none');
    });

    //datepicker
    $.datepicker.regional['cs'] = {
        renderer: $.ui.datepicker.defaultRenderer,
    monthNames: ['leden','únor','březen','duben','květen','červen','červenec','srpen','září','říjen','listopad','prosinec'],
    monthNamesShort: ['led','úno','bře','dub','kvě','čer','čvc','srp','zář','říj','lis','pro'],
        dayNames: ['neděle', 'pondělí', 'úterý', 'středa', 'čtvrtek', 'pátek', 'sobota'],
        dayNamesShort: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
    dayNamesMin: ['ne','po','út','st','čt','pá','so'],
        dateFormat: 'dd.mm.yyyy',
        firstDay: 1,
        prevText: '&#x3c;Dříve', prevStatus: '',
        prevJumpText: '&#x3c;&#x3c;', prevJumpStatus: '',
        nextText: 'Později&#x3e;', nextStatus: '',
        nextJumpText: '&#x3e;&#x3e;', nextJumpStatus: '',
        currentText: 'Nyní', currentStatus: '',
        todayText: 'Nyní', todayStatus: '',
        clearText: '-', clearStatus: '',
        closeText: 'Zavřít', closeStatus: '',
        yearStatus: '', monthStatus: '',
        weekText: 'Týd', weekStatus: '',
        dayStatus: 'DD d MM',
        defaultStatus: '',
        isRTL: false
    };
  $.datepicker.setDefaults( $.datepicker.regional[ "cs" ] );
    $(".datepicker").datepicker(
            {
                dateFormat: "yy-mm-dd",
                showOtherMonths: true,
                selectOtherMonths: true
            });
    $(".datepickercz").datepicker(
            {
                dateFormat: "dd.mm.yy",
                showOtherMonths: true,
                selectOtherMonths: true
            });
    $(".datetimepicker").datepicker(
            {
                dateFormat: "yy-mm-dd hh:ii",
                showOtherMonths: true,
                selectOtherMonths: true
            });

  //nastavení ligtboxu pro fotogalerie - typ 3
  //document.addEventListener('simpleLightbox-ready', function() {
//    if( $('.fotogalerie').length > 0 )
//    {
//      $('.fotogalerie').simpleLightbox();
//    }
  //});
     
  
    //refreshGalerie
    //galerie typu 4
    $('.fotogalerie').each(function () {
      initGalerie( this );
    });
     

  $(".info_tool, .info_tool_bez").tooltip({
    position: {
      my: "center bottom",
      at: "right top"
    },
    content: function() {
        return $(this).attr('title');
    }
  });

  //aby kotvy scrolovaly o něco níž kvůli fixní pozici menu
  jQuery(window).on("load", function () {
    var urlHash = window.location.hash.substring(1);
    if( urlHash ) {
      kotva_posun( $( "#" + urlHash ), null );
    }
  });
  var posun = $('.titulek').height() * 1.2;
  if( $('.info_vrsek').length > 0 ) posun = posun + $('.info_vrsek').height();
  // Všechny odkazy, kterým atribut href začíná znakem #
  $('a[href^="#"]').click(function(event) {
    kotva_posun( $(this.hash), event );
  });

  function kotva_posun( element, event )
  {
    // Pokud neexistuje, neprovedeme nic
    if (!element.length) {
            return false;
    }
    // Zastavíme defaultní operaci - přesměrování na kotvu
    if( event )event.preventDefault();
    // Scrollujeme stránku na daný element
    $('body,html').animate({
            scrollTop: element.offset().top - posun
    }, 500);
  }

  if( $( '.info_vrsek' ).length > 0 ) //<p> přidat class hidden a <span>2022-07-26 18:54:59</span>
  {
    //načte datum a čas
    var datum_cas  = new Date( $( '.info_vrsek span' ).html() ).getTime();
    var jazyk = $( '#js_web_lang_zkr' ).val();

    var x = setInterval(function() {
      var now = new Date().getTime();

      var rozdil_time = datum_cas - now;

      var days = Math.floor(rozdil_time / (1000 * 60 * 60 * 24));
      var hours = Math.floor((rozdil_time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((rozdil_time % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((rozdil_time % (1000 * 60)) / 1000);

      if( jazyk === 'cz' )
        $( '.info_vrsek span' ).html( days + ' ' + ( days === 1 ? 'den' : ( days >= 5 || days === 0 ? 'dní' : 'dny' ) ) + ' ' + hours + ' ' + ( hours === 1 ? 'hodina' : ( hours >= 5 || hours === 0 ? 'hodin' : 'hodiny' ) ) + ' ' + minutes + ' ' + ( minutes === 1 ? 'minuta' : ( minutes >= 5 || minutes === 0 ? 'minut' : 'minuty' ) ) + ' ' + seconds + ' ' + ( seconds === 1 ? 'sekunda' : ( seconds >= 5 || seconds === 0 ? 'sekund' : 'sekundy' ) ) );
      else if( jazyk === 'sk' )
        $( '.info_vrsek span' ).html( days + ' ' + ( days === 1 ? 'deň' : ( days >= 5 || days === 0 ? 'dní' : 'dni' ) ) + ' ' + hours + ' ' + ( hours === 1 ? 'hodina' : ( hours >= 5 || hours === 0 ? 'hodín' : 'hodiny' ) ) + ' ' + minutes + ' ' + ( minutes === 1 ? 'minúta' : ( minutes >= 5 || minutes === 0 ? 'minút' : 'minúty' ) ) + ' ' + seconds + ' ' + ( seconds === 1 ? 'sekunda' : ( seconds >= 5 || seconds === 0 ? 'sekúnd' : 'sekundy' ) ) );
      else if( jazyk === 'de' || jazyk === 'at' || jazyk === 'ch' )
        $( '.info_vrsek span' ).html( days + ' ' + ( days === 1 ? 'Tag' : 'Tage' ) + ' ' + hours + ' ' + ( hours === 1 ? 'Stunde' : 'Stunden' ) + ' ' + minutes + ' ' + ( minutes === 1 ? 'Minute' : 'Minuten' ) + ' ' + seconds + ' ' + ( seconds === 1 ? 'Sekunde' : 'Sekunden' ) );
      else
        $( '.info_vrsek span' ).html( days + "d " + hours + "h " + minutes + "m " + seconds + "s" );

      $( '.info_vrsek p' ).removeClass( "hidden" );

      //pokud někdo nechá načtený web a vyprší interval, tak se lišta skryje
      if ( rozdil_time < 0 ) {
        clearInterval(x);
        $( '.info_vrsek p' ).addClass( "hidden" );
      }
    }, 1000);//po 1 sekundě
  }

  //výběr variant pluginu rezervace apartmánů
  if ( $("#formApartmany_select").length > 0 )
  {
    $("#formApartmany_select").change( function() {
      var id = $("#formApartmany_select").val();
      if ( id > 0 )
      {
        $("tr.formapartmany_var").hide();
        $("select[name=id_varianty]").attr( 'disabled', true );
        $("select#formapartmany_svar"+id).attr( 'disabled', false );
        $("tr#formapartmany_var"+id).show();
      }
    });
  }

  //odeslání testu na e-mail
  $('#test-na-email').click(function()
  {
    var jmeno = prompt("Vaše jméno, případně kontakt:", "");
    $('#test-jmeno').val( jmeno );
    $('#test-na-email-form').submit();
    return false;
  });

  //našeptávač ve vyhledávání
  if ( $('input[name=hledane]').length > 0 )
  {
    var lasttype = '';
    $("input[name=hledane]")
        .autocomplete({
            source: root + "/rsadmin/_funkce/vyhledavani_autocomplete.php",
            minLength: 3,
            appendTo: "header",
            position: { my: "left top", of: "header", collision: "none" },
            open: function (event, ui) {
                $(".ui-autocomplete").css({
                    width: $("header").outerWidth(),
                    left: "0",
                    right: "0",
                });
            },
            select: function (event, ui) {
                location.href = ui.item.url;
            },
        })
        .data("uiAutocomplete")._renderItemData = function (ul, item) {
        console.dir(item);

        var nadp = false;
        var res = "";

        if (lasttype !== item.typ) {
            lasttype = item.typ;
            nadp = true;
        }

        if (item.typ === "kategorie") {
            if (nadp) $('<div class="ui-autocomplete-kat"></div>').appendTo(ul);
            res = $("<li class='vyhledavani_kategorie'></li>").data(
                "ui-autocomplete-item",
                item
            );
            res.append(
              '<a href="' +
                item.url +
                '">' +
                (item.img ? '<div class="ui-autocomplete-obrazek"><img src="' + item.img + '" /></div>' : '') +
                '<div class="ui-autocomplete-text">' +
                item.label +
                "</div></a>"
            );
        } else if (item.typ === "eshop") {
            if (nadp) $('<div class="ui-autocomplete-kat"></div>').appendTo(ul);
            res = $("<li class='vyhledavani_produkt'></li>").data(
                "ui-autocomplete-item",
                item
            );
            res.append(
                '<a href="' +
                    item.url +
                    '"><div class="ui-autocomplete-obrazek"><img src="' +
                    item.img +
                    '" /></div><div class="ui-autocomplete-text">' +
                    item.label +
                    '</div><div class="ui-autocomplete-price"><div class="ui-autocomplete-priceold">' +
                    item.cena_old +
                    "</div>" +
                    item.cena +
                    "</div></a>"
            );
        } else if (item.typ === "clanek") {
            if (nadp) $('<div class="ui-autocomplete-kat"></div>').appendTo(ul);
            res = $("<li class='vyhledavani_clanek'></li>").data(
                "ui-autocomplete-item",
                item
            );
            res.append(
                '<a href="' +
                    item.url +
                    '"><div class="ui-autocomplete-obrazek"><img src="' + item.img + '" /></div><div class="ui-autocomplete-text">' +
                    item.label +
                    "</div></a>"
            );
        } else if (item.typ === "rezervace") {
            res = $("<li></li>").data("ui-autocomplete-item", item);
            res.append(
                '<a href="' +
                    item.url +
                    '"><div class="ui-autocomplete-obrazek"><img src="' +
                    item.img +
                    '" /></div><div class="ui-autocomplete-text">' +
                    item.label +
                    "<span>" +
                    item.desc +
                    "</span></div></a>"
            );
        } else if (item.typ === "preklep") {
            res = $("<li class='vyhledavani_odkaz'></li>").data(
                "ui-autocomplete-item",
                item
            );
            res.append(
                item.label +
                    '<a href="' +
                    item.url +
                    '"><div class="ui-autocomplete-extra">' +
                    item.desc +
                    "</div></a>"
            );
        } else if (item.typ === "extra") {
            res = $("<li class='vyhledavani_odkaz'></li>").data(
                "ui-autocomplete-item",
                item
            );
            res.append(
                '<a><div class="ui-autocomplete-extra">' +
                    item.label +
                    "</div></a>"
            );
        }
        return res.appendTo(ul);
    };
  }
  $(document).on('click', '.vyhledavani_open', function()
  {
    if (!$('#vyhledavani').hasClass('show'))
    {
        $('#vyhledavani').addClass('show');
        $('.vyhledavani_overlay').show();
        $('input[name=hledane]').trigger('select');
    }
    else
    {
        $('#vyhledavani').removeClass('show');
        $('.vyhledavani_overlay').hide();
    }
    return false;
  });
  $(document).on("click", ".vyhledavani_overlay, .vyhledavani_close", function () {
    $(".ui-autocomplete").html('');
    $("input[name=hledane]").val('');
    $("#vyhledavani").slideUp(200, function () {

        });
    $('#vyhledavani').removeClass('show');
    $('.vyhledavani_overlay').hide();
  });
    //obnovení podkategorie po změně řazení
  $('li.sorthead a').click( function()
    {
        var self = $(this);
        self.parent().parent().find('li:not(:first)').remove();
        self.parent().after('<p class="stred"><img src="' + root + '/libs/jquery/images/loading.gif" alt="loading" /></p>');
    $.get( root + "/rsadmin/_funkce/podkategorie_sort.php", { sortid: self.attr('data-sortid'), subsort: self.attr('data-subsort') })
    .done( function( data )
                {
                    self.parent().parent().find('p').remove();
      self.parent().after( data );

      self.parent().find( 'a.aktivni' ).removeClass( 'aktivni' );
      self.addClass( 'aktivni' );
                });
        return false;
    });

    $(".bloky").on( 'click', '#dalsi_clanky',function() { /*, #eshop_produkty .str_dalsi*/
        $('#loading img').show();
        var dalsi_strana = $('.strankovani .str_dalsi').attr('data-stranka');
        var filtry_eshop_odkaz = root + "/rsadmin/_funkce/dalsi_clanky.php";

        $.get(filtry_eshop_odkaz, {katmr: $('#kategori_str').val(), str:dalsi_strana}, function( html )
        {
            $(".strankovani").remove();
            $(".strankovani_tlacitko").remove();
            $(".bloky").html($(".bloky").html()+html);
            $('#loading img').hide();
            if($('.bloky .str_dalsi').html() == null){
                $("#dalsi_clanky").hide();
            }
        });

        return false;
    });
    /*Fotogalerie - kdybychom chtěli aby se fotky načítali jako auto loading
    var position = $ (window ).scrollTop();
    $( window ).scroll(function()
    {
        var scroll = $( window ).scrollTop();
        if( $( ".ovladani_foto_celek" ).length === 0 ) return false;
        if( $( ".strankovani_tlacitko" ).is( ":visible" ) !== true ) return false;
        if( scroll > position && scroll + $( window ).height() > $( document ).height() - ( $( "#zapati" ).outerHeight() * 0.9 ) )
        {
          $( ".dalsi_fotky" ).click();
        }
        position = scroll;
    });*/
    /*var position2 = $ (window ).scrollTop();
    $( window ).scroll(function()
    {
        var scroll = $( window ).scrollTop();
        if( $( "#dalsi_produkty" ).is( ":visible" ) !== true ) return false;
        if( scroll > position2 && scroll + $( window ).height() > $( document ).height() - ( $( "#zapati" ).outerHeight() * 0.9 ) )
        {
          $( "#dalsi_produkty" ).click();
        }
        position2 = scroll;
    }); */

    var zamek_strana = 0;
    $(".dalsi_fotky").click(function() {
      if( zamek_strana ===  $( this ).attr( "data-strana" ) ) return false;
      zamek_strana = $( this ).attr( "data-strana" );
      var prvek = $(this);
      var id_gal = $( this ).attr( "data-id" );
        $( '.loading_' + id_gal ).show();

        $.get( root + "/rsadmin/_funkce/dalsi_fotky.php", { galerie: id_gal, strana: zamek_strana, stitek: $( this ).attr( "data-stitek" ), zobr: $('#typ_zobr').val() }, function( data )
        {
            data = jQuery.parseJSON( data )
            if( data.strana === "-1" )
            {
              $( ".strankovani_tlacitko_" + id_gal ).hide();
            }
            $( prvek ).attr( "data-strana", data.strana );
            $( ".fotogalerie_" + id_gal ).append( data.fotky );
            refreshGalerie( id_gal );
            $( '.loading_' + id_gal ).hide();
        });

        return false;
    });

    //lazy load produktů
    $("#dalsi_produkty").click(function()
    {
        if( zamek_strana >= parseInt( $( '#eshop_produkty .str_dalsi' ).attr( 'data-stranka' ) ) || $.isNumeric( $( '#eshop_produkty .str_dalsi' ).attr( 'data-stranka' ) ) !== true ){ return false; }
        $('#loading img').show();
        zamek_strana = $('#eshop_produkty .str_dalsi').attr('data-stranka');
        var filtry_eshop_odkaz = root + "/rsadmin/_funkce/eshop_dalsi_produkty.php";
        if ($(location).attr('href').indexOf('?') != -1)
        {
           var filtry_eshop = $(location).attr('href').split("?");
           if(filtry_eshop[1])
           {
             filtry_eshop_odkaz =  root + "/rsadmin/_funkce/eshop_dalsi_produkty.php?"+filtry_eshop[1];
           }
        }

        $.get(filtry_eshop_odkaz, {katmr: $('#kategori_str').val(), str:zamek_strana}, function( html )
        {
            $( ".delete_lazy_load" ).remove();
            $("#eshop_produkty").html($("#eshop_produkty").html()+html);
            $('#loading img').hide();
            if($.isNumeric( $( '#eshop_produkty .str_dalsi' ).attr( 'data-stranka' ) ) !== true){
                $("#dalsi_produkty").hide();
            }
        });

        return false;
    });

    //kliknutí na tlačítko přihlásit zahashuje zadané heslo, aby se nepřenášelo v nešifrované formě
  $('#login_button').click( function()
    {
    if ( $('#login_password').length > 0 )
        {
            // Create a new element input, this will be our hashed password field.
      var p = document.createElement( "input" );

            // Add the new element to our form.
      $('#login_button').before( p );
            p.name = "phash";
            p.type = "hidden";
      p.value = hex_sha512( $('#login_password').val() );

            // Make sure the plaintext password doesn't get sent.
      $('#login_password').val( '' );
        }
    });
  $('#logs_button').click( function()
    {
    if ( $('#logs_password').length > 0 )
        {
            // Create a new element input, this will be our hashed password field.
      var p = document.createElement( "input" );

            // Add the new element to our form.
      $('#logs_button').before( p );
            p.name = "phash";
            p.type = "hidden";
      p.value = hex_sha512( $('#logs_password').val() );

            // Make sure the plaintext password doesn't get sent.
      $('#logs_password').val( '' );
        }
    });

  //kalendář obsazenosti
  function RefreshCalendar( link )
  {
    $( '#obsazenost_uvod' ).html('').addClass( 'loading' );

    $.get( root + "/rsadmin/_funkce/rezervace_obsazenost.php", { link: link })
    .done( function( data )
    {
      $( '#obsazenost_uvod' ).html( data );

      $('#obsazenost_uvod a').on( 'click', function()
      {
        RefreshCalendar( $(this).attr('href') );
        return false;
      });

      $( '#obsazenost_uvod' ).removeClass( 'loading' );
    });

    return false;
  }
  //RefreshCalendar( '' );

  /* funkce na responzivitu textu */
  var element_id = $(".blok_element_id").val();
  if ( element_id ) $("#"+element_id+",html").css({"font-size":$("#"+element_id).width()/2560*100});

  //ošetření vícenásobného odeslání formuláře
//  var submitButton = null;
//  $('form').submit( function(e)
//  {
//    if ( $(this).hasClass( 'already-submitted' ) )
//    {
//      e.preventDefault();
//      return false;
//    }
//    else
//    {
//      $(this).addClass( 'already-submitted' );
//      if ( submitButton !== null )
//      {
////        submitButton.find('img').attr('src',root+'/images/loading.gif');
////        submitButton.addClass('loading');
//      }
//      submitButton = null;
//      return true;
//    }
//  });
//  $('input[type="submit"],button#page_save').click( function() { submitButton = $(this); });


/* funkce na responzivitu textu při změně velikosti okna nebo zoomování */
$(window).on("resize.zoom",function()
{
  var element_id = $(".blok_element_id").val();
  if ( element_id ) $("#"+element_id+",html").css({"font-size":$("#"+element_id).width()/2560*100});
});


    $('.prava_text div div:first-of-type div').click(function () {

        if ($(this).children('div').attr('class') !== 'show')
        {
            $('.prava_text div div:first-of-type div').removeClass('show');
            $(this).children('div').addClass('show');

        } else
        {
            $('.prava_text div div:first-of-type div').removeClass('show');
        }

    });
    $(document).mouseup(function (e)
    {
        var container = $('.prava_text div div:first-of-type div');

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0)
        {
            $('.prava_text div div:first-of-type div').removeClass('show');
        }
    });

    $('.prava_text div').first().addClass('visible');
    $('.prava_text>div:nth-of-type(2)').addClass('wait');

    $(".prava_text>div").each(function (index) {
      $(this).attr('data-pozice',index);
    });

  $('#slider_h3').click(function () {
    if(!$(this).hasClass( "dis_button" ))
    {
      $(this).addClass('dis_button');

      var visible = $('.full_3 .visible');
      var wait = $('.full_3 .wait');
      visible.animate({left: '100%'}, function () {
        visible.removeClass('visible');
        visible.css({left: '0'});

        wait.removeClass('wait');
        wait.addClass('visible');
        var next = parseFloat(wait.attr('data-pozice')) + 1;
        var ok = 0;
        $(".full_3 .prava_text>div").each(function (index) {
          if ($(this).attr('data-pozice') == next)
          {
            ok = 1;
          }
        });
        if (ok == 0)
        {
          next = 0;
        }
        $(".full_3 .prava_text>div").each(function (index) {
          if ($(this).attr('data-pozice') == next)
          {
            $(this).addClass('wait');

            return;
          }
        });
        $('.dis_button').removeClass('dis_button');
      });
    }
  });
  $('#slider_h3_back').click(function () {
    if(!$(this).hasClass( "dis_button" ))
    {
      $(this).addClass('dis_button');

      var visible = $('.full_3 .visible');
      var next = parseFloat(visible.attr('data-pozice')) - 1;
      if(next < 0)
      {
        $(".full_3 .prava_text>div").each(function (index) {
            next = parseFloat($(this).attr('data-pozice'));
        });
      }

      var wait = "";
      $(".full_3 .prava_text>div").each(function (index) {
        if ($(this).attr('data-pozice') == next)
        {
          wait = $(this);
        }
      });

      visible.animate({left: '-100%'}, function () {
        $(".wait").removeClass('wait');

        visible.removeClass('visible');
        visible.css({left: '0'});
        visible.addClass('wait');

        wait.addClass('visible');
        $('.dis_button').removeClass('dis_button');
      });
    }
  });

    $('.prava_img div').first().addClass('visible');

    $('.prava_img>div:nth-of-type(2)').addClass('wait');

    $(".prava_img>div").each(function (index) {
      $(this).attr('data-pozice',index);
      $(this).addClass('telslider');
    });

     $('#slider_h4').click(function () {

       var visible = $('.full_4 .visible');
       var wait = $('.full_4 .wait');
         visible.animate({left: '150%'}, function() {
            visible.removeClass('visible');
             visible.css({left:'0'});
            wait.removeClass('wait');
            wait.addClass('visible');
            var next = parseFloat(wait.attr('data-pozice'))+1;
            var ok = 0;
             $(".full_4 .prava_img>div").each(function (index) {
              if($(this).attr('data-pozice') == next)
              {
                ok = 1;
              }
            });
            if(ok == 0)
            {
              next = 0;
            }
            $(".full_4 .prava_img>div").each(function (index) {
              if($(this).attr('data-pozice') == next)
              {
                $(this).addClass('wait');

                return;
              }
            });
      });
     });


//    $('.prava_img div').click(function () {
//
//        if ($(this).children('div').attr('class') !== 'show')
//        {
//            $('.prava_img>div').children('div').removeClass('show');
//            $(this).children('div').addClass('show');
//
//        } else
//        {
//            $('.prava_img>div').children('div').removeClass('show');
//        }
//
//    });
//    $(document).mouseup(function (e)
//    {
//        var container = $('.prava_img').children('div');
//
//        // if the target of the click isn't the container nor a descendant of the container
//        if (!container.is(e.target) && container.has(e.target).length === 0)
//        {
//            $('.prava_img>div').children('div').removeClass('show');
//        }
//    });

//    $('.prava_img_6 div').click(function () {
//
//        if ($(this).children('div').attr('class') !== 'show')
//        {
//            $('.prava_img_6>div').children('div').removeClass('show');
//            $(this).children('div').addClass('show');
//
//        } else
//        {
//            $('.prava_img_6>div').children('div').removeClass('show');
//        }
//
//    });
//    $(document).mouseup(function (e)
//    {
//        var container = $('.prava_img_6').children('div');
//
//        // if the target of the click isn't the container nor a descendant of the container
//        if (!container.is(e.target) && container.has(e.target).length === 0)
//        {
//            $('.prava_img_6>div').children('div').removeClass('show');
//        }
//    });


    $('.kontakty_4_text div div').click(function () {


        if ($(this).children('p').attr('class') !== 'show')
        {


            $(this).children('p').slideDown("slow", function () {

            });
            $(this).children('p').addClass('show');
            $(this).addClass('open');

        } else
        {

            $(this).children('p').slideUp("slow", function () {

            });
            $(this).children('p').removeClass('show');
            $(this).removeClass('open');

        }

    });
    var udelat = 0;
    $(".leva_text .pkat_text ").mouseenter(function () {
      if(udelat === 0)
      {
        if($(this).parent('div').attr('id-slider') !== $('.full_4 .visible').attr('data-pozice'))
        {
        udelat = 1;
        var slide = $(this).attr('id-slider');
        var exists = 0;
        $(".full_4 .prava_img>div").each(function (index, element ) {
           if(slide === $(element).attr('data-pozice'))
           {
             exists = 1;
           }
        });
        if( exists === 0 ) { udelat = 0; return; }

        var visible = $('.full_4 .visible');
        var wait = $('.full_4 .wait');
             visible.animate({left: '150%'}, function() {
             visible.removeClass('visible');
             visible.css({left:'0'});
             wait.removeClass('wait');

             var next = parseFloat(slide)+1;
             var ok = 0;
            $(".full_4 .prava_img>div").each(function (index, element ) {
               if($(element).attr('data-pozice') == next)
               {
                 ok = 1;
               }

               if(slide == $(element).attr('data-pozice'))
               {
                 $(element).addClass('visible');
               }
             });
             if(ok == 0)
             {
               next = 0;
             }
             $(".full_4 .prava_img>div").each(function (index, element) {
               if($(element).attr('data-pozice') == next)
               {
                 $(element).addClass('wait');
                  udelat = 0;
                 return;
               }
             });
       });
       }
      }
    });

// $(".kosik_obrazek").mouseenter(function () {
//
//        $(this).children('a').children('img').attr("src","/images/kosik_g.png");
//
//    });
//    $(".kosik_obrazek").mouseleave(function () {
//
//        $(this).children('a').children('img').attr("src","/images/kosik_w.png");
//
//    });

    $(".kontakty_4_text div div").mouseenter(function () {

        $(this).closest('div').addClass("opens");
    });
    $(".kontakty_4_text div div").mouseleave(function () {

        $(this).closest('div').removeClass("opens");

    });

    $(".zapati_cast div div a").mouseenter(function () {

        $(this).closest('div').css("background-color", "#0a0");
    });
    $(".zapati_cast div div a").mouseleave(function () {

        $(this).closest('div').css("background-color", "transparent");

    });







//    $('.leva_img strong a').magnificPopup({
//        type: 'iframe'
//    });
//    $('.prava_img strong a').magnificPopup({
//        type: 'iframe'
//    });
//    $('.leva_img_5 strong a').magnificPopup({
//        type: 'iframe'
//    });
//    $('.prava_img_6 strong a').magnificPopup({
//        type: 'iframe'
//    });

//    $('.leva_text div a').on('click', function (event) {
//        event.preventDefault();
//
//        var gallery = $(this).attr('href');
//
//        $(gallery).magnificPopup({
//            delegate: 'a',
//            type: 'image',
//            gallery: {
//                enabled: true
//            }
//        }).magnificPopup('open');
//    });

//    var clanek = $('#slider_clanky').children('div').first().html();
//    $('#slider_clanky').children('div').last().html(clanek);
//    var matched = $("#slider_clanky div");
//
//    var clikc = 1;
//    $('#right-button').click(function (event) {
//        event.preventDefault(0);
//        $('#slider_clanky').animate({
//            scrollLeft: "+=" + (parseFloat($('.prava_text_5').width().toFixed(2)))
//        }, "slow");
//        clikc++;
//        if (clikc == matched.length)
//        {
//            $('#slider_clanky').animate({"scrollLeft": "-=" + (parseFloat($('#slider_clanky').width().toFixed(2))) * matched.length}, 0);
//            clikc = 1;
//        }
//    });
//
//    $('#left-button').click(function (event) {
//        event.preventDefault(0);
//        $('#slider_clanky').animate({
//            scrollLeft: "-=" + (parseFloat($('.prava_text_5').width().toFixed(2)))
//        }, "slow");
//        clikc--;
//        if (clikc < 1)
//        {
//            $('#slider_clanky').animate({"scrollLeft": "+=" + (parseFloat($('#slider_clanky').width().toFixed(2))) * matched.length}, 0);
//            $('#slider_clanky').animate({
//                scrollLeft: "-=" + (parseFloat($('.prava_text_5').width().toFixed(2)))
//            }, "slow");
//            clikc = (matched.length - 1);
//        }
//    });
//
//
//    var clanek_p = $('#posledni_clanek').children('.clanek').first().html();
//    $('#posledni_clanek').children('.clanek').last().html(clanek_p);
//    var matched_p = $("#posledni_clanek .clanek");
//
//    var clikc_p = 1;
//    $('#right-button-clanky').click(function (event) {
//        event.preventDefault(0);
//        $('#posledni_clanek').animate({
//            scrollLeft: "+=" + (parseFloat($('#posledni_clanky').width().toFixed(2)))
//        }, "slow");
//        clikc_p++;
//        if (clikc_p == matched_p.length)
//        {
//            $('#posledni_clanek').animate({"scrollLeft": "-=" + (parseFloat($('#posledni_clanek').width().toFixed(2))) * matched_p.length}, 0);
//            clikc_p = 1;
//        }
//    });
//
//    $('#left-button-clanky').click(function (event) {
//        event.preventDefault(0);
//        $('#posledni_clanek').animate({
//            scrollLeft: "-=" + (parseFloat($('#posledni_clanky').width().toFixed(2)))
//        }, "slow");
//        clikc_p--;
//        if (clikc_p < 1)
//        {
//            $('#posledni_clanek').animate({"scrollLeft": "+=" + (parseFloat($('#posledni_clanek').width().toFixed(2))) * matched_p.length}, 0);
//            $('#posledni_clanek').animate({
//                scrollLeft: "-=" + (parseFloat($('#posledni_clanky').width().toFixed(2)))
//            }, "slow");
//            clikc_p = (matched_p.length - 1);
//        }
//    });

    $('#menu_show').click(function () {

        if (!$('#menu').hasClass('show'))
        {
            $("#menu").slideDown(200, function () {

            });
            $('#menu').addClass('show');
        }

        else
        {
            $("#menu").slideUp(200, function () {

            });
            $('#menu').removeClass('show');
        }
        return false;
    });

  $(document).on("click", "#menu_show_new, .menu_hide_new", function () {
    if (!$('#menu').hasClass('show'))
    {
      $("#menu").slideDown(100, function () {

      });
      $('#menu').addClass('show');
    } else
    {
      $("#menu").slideUp(100, function () {

      });
      $('#menu').removeClass('show');
    }
    return false;
  });
  $(window).bind("resize", function (e) {

    $('#nemu_dalsi').removeClass('show');
    $('#nemu_dalsi').hide();
    $('#open_tablet').removeClass('open_obr');
    if (/*$('body').width() > 1000*/ window.matchMedia('(min-width: 1001px)').matches)
    {
      $('#menu').show();
      $('#menu').removeClass('show');
      $('#menu').css("display", "");
    }
    else if(/*$('body').width() <= 1000*/window.matchMedia('(max-width: 1000px)').matches)
    {
      $('#menu').hide();
      $('#menu').removeClass('show');
      $('#menu').css("display", "");
    }
  });

      $('#open_tablet').click(function () {

        if (!$('#nemu_dalsi').hasClass('show'))
        {
            $("#nemu_dalsi").slideDown(200, function () {

            });
            $('#nemu_dalsi').addClass('show');
             $('#open_tablet').addClass('open_obr');
        }

        else
        {
            $("#nemu_dalsi").slideUp(200, function () {

            });
            $('#nemu_dalsi').removeClass('show');
            $('#open_tablet').removeClass('open_obr');
        }
        return false;
    });

    /*if ($('body').width() <= 800)
    {
        $('.video_uvod').html('');
    }
    else
    {
       $('.video_uvod_tel').html('');
    }*/


    $('.zapati_cast_1').children('div').first().children('a').mouseenter(function () {


        $(this).children('em').first().children('img').animate({"top": "-=10px"}, 200, "linear");
        $(this).children('em').first().children('img').animate({"top": "+=10px"}, 200, "linear");
        $(this).children('em').first().children('img').animate({"top": "-=10px"}, 200, "linear");
        $(this).children('em').first().children('img').animate({"top": "+=10px"}, 200, "linear");
    });
 
    $('#foto_velka').click(function () {

      $('.foto_vybrano').removeClass('foto_vybrano');
      $('#foto_velka').addClass('foto_vybrano');
      $('.fotka').removeClass('fotka_mensi');
      $('#typ_zobr').val('');

    });
    $('#foto_mala').click(function () {
      $('.foto_vybrano').removeClass('foto_vybrano');
      $('#foto_mala').addClass('foto_vybrano');
      $('.fotka').addClass('fotka_mensi');
      $('#typ_zobr').val('fotka_mensi');
    });



  $(".kategorie_select").each(function (index, element) {
    $(element).find('.aktivni_eshop').each(function (index, element_sec) {
      $(element_sec).closest('.kategorie_select').children('.kategorie_select_btn').children('span').text($(element_sec).prop("innerText"));
      return false;
    });
  });
  $('.kategorie_button').click(function () {

    if (/*$('body').width() <= 1000*/window.matchMedia('(max-width: 1000px)').matches)
    {
      $(this).closest('.kategorie_select').children('.kategorie_select_btn').children('span').text($(this).prop("innerText"));
      $(this).closest('.kategorie_select').removeClass("active");
      $(this).closest('.kategorie_select').children('.kategorie_buttons_select').slideUp();
    }

  });
  $('.kategorie_select_btn').click(function () {

    if ($(this).parent('.kategorie_select').children('.kategorie_buttons_select').is(":hidden"))
    {
      $(".razeni_buttons_select").slideUp();
      $('.active').removeClass("active");
      $(this).parent('.kategorie_select').addClass("active");
      $(this).parent('.kategorie_select').children('.kategorie_buttons_select').slideDown();
    } else
    {
      $(this).parent('.kategorie_select').removeClass("active");
      $(this).parent('.kategorie_select').children('.kategorie_buttons_select').slideUp();
    }
  });
 
  $(window).bind("resize scroll", function (e) {
    if ( window.matchMedia('(max-width: 600px)').matches && $('.kategorie_buttons_select').is(":visible"))
    {
      $('.kategorie_buttons_select').slideUp();
      $('.active').removeClass("active");
    }
  });
  $(window).click(function (e) {
    if ( window.matchMedia('(max-width: 600px)').matches && $('.kategorie_buttons_select').is(":visible"))
    {
      var container = $(".kategorie_select_btn");
      if (!container.is(e.target) && container.has(e.target).length === 0)
      {
        $('.kategorie_buttons_select').slideUp();
        $('.active').removeClass("active");
      }
    }
  });

  if( $(".ona_ovladani").length > 0 )
  {
    const rect = $(".ona_ovladani")[0].getBoundingClientRect();
    $('.onas_2_text').css('left', rect.left);
    var prvni_slider = 0;
    $(".onas_2_text>div").each(function (index, element) {
        if($(this).hasClass('prvni_nejclanek'))
        {
          prvni_slider = index + 1;
        }
        else $(this).attr('data-slide', index - prvni_slider);
        if (index == prvni_slider)
          $(this).addClass('vybrano_onas');

        if(index === 2 && /*$('body').width() > 1000*/ window.matchMedia('(min-width: 1001px)').matches)
        {
          $('.onas_left_1').hide();
          $('.onas_right_1').hide();
        }
        else if (isInViewport($(element)[0]))
        {
          $('.onas_left_1').hide();
          $('.onas_right_1').hide();
        } else
        {
          $('.onas_right_1').css('opacity', '100%');
           $('.onas_left_1').css('opacity', '30%');
          $('.onas_left_1').show();
          $('.onas_right_1').show();
        }
      });
  }

  $(window).bind("resize", function (e) {
    if( $(".ona_ovladani").length > 0 )
    {
      $(".vybrano_onas").removeClass('vybrano_onas');
      $('*[data-slide="0"]').addClass('vybrano_onas');

      const rect = $(".ona_ovladani")[0].getBoundingClientRect();

      $('.onas_2_text').css('left', rect.left);

      $(".onas_2_text>div").each(function (index, element) {

        if(index === 2 && /*$('body').width() > 1000*/ window.matchMedia('(min-width: 1001px)').matches)
        {
          $('.onas_left_1').hide();
          $('.onas_right_1').hide();
        }
        else if (isInViewport($(element)[0]))
        {
          $('.onas_left_1').hide();
          $('.onas_right_1').hide();
        } else
        {
          $('.onas_right_1').css('opacity', '100%');
           $('.onas_left_1').css('opacity', '30%');
          $('.onas_left_1').show();
          $('.onas_right_1').show();
        }
      });
    }
  });

  $('.onas_right_1').click(function () {

    if(!$(this).hasClass( "dis_button" ))
    {
      $(this).addClass('dis_button');

      var aktual = $('.vybrano_onas');
      var next = parseFloat(aktual.attr('data-slide')) + 1;
      var next_next = parseFloat(next) + 1;

      if ($('*[data-slide="' + next + '"]').length && $('.onas_right_1').css('opacity') == 1)
      {
        var next_el = $('*[data-slide="' + next + '"]');
        var posun = parseFloat(aktual.width()) - parseFloat($('.onas_2_text').css('left')) + parseFloat(aktual.css('margin-right'));

        $('.onas_2_text').animate({left: '-' + posun + 'px'}, function () {
          aktual.removeClass('vybrano_onas');
          next_el.addClass('vybrano_onas');
          if (next > 0)
          $('.onas_left_1').css('opacity', '100%');
          $(".onas_2_text div").each(function (index ,element) {
            if ($(element).attr("data-slide") > next)
            {
               if(isInViewport($(element)[0]))$('.onas_right_1').css('opacity', '30%');
               else $('.onas_right_1').css('opacity', '100%');
            }
          });
         $('.dis_button').removeClass('dis_button');
        });
      }
      if ($('*[data-slide="' + next_next + '"]').length == 0)
      {
        $('.onas_right_1').css('opacity', '30%');
      }
    }
  });

  $('.onas_left_1').click(function () {
    if(!$(this).hasClass( "dis_button" ))
    {
      $(this).addClass('dis_button');

      var aktual = $('.vybrano_onas');
      var next = parseFloat(aktual.attr('data-slide')) - 1;
      var next_next = parseFloat(next) - 1;
      if ($('*[data-slide="' + next + '"]').length && $('.onas_left_1').css('opacity') == 1)
      {
        var next_el = $('*[data-slide="' + next + '"]');
        var posun = parseFloat($('.onas_2_text').css('left')) + parseFloat(next_el.width()) + parseFloat(aktual.css('margin-right'));
        $('.onas_2_text').animate({left: '' + posun + 'px'}, function () {
          aktual.removeClass('vybrano_onas');
          next_el.addClass('vybrano_onas');
          if (next == 0)
            $('.onas_left_1').css('opacity', '30%');
           $('.onas_right_1').css('opacity', '100%');

        $('.dis_button').removeClass('dis_button');
        });
      }
      if ($('*[data-slide="' + next_next + '"]').length == 0)
      {
        $('.onas_left_1').css('opacity', '30%');
      }
    }
  });

  //odkazování pro šablonu uvod_3_new.tpl
  $('.onas_2_hp .onas_2_text div div').click(function () {
    if($(this).parent('div').find('a').attr("href"))window.location.href = $(this).parent('div').find('a').attr("href");

  });
  //odkazování pro šablonu uvod_3_new.tpl
  $('.blog_2 .onas_2_text div div').click(function () {
    if($(this).closest('a').attr("href"))window.location.href = $(this).closest('a').attr("href");
  });
  //otevření mailing formuláře klikem na tlačítko
  $( "#mailing_open_dialog" ).click( function(){ openDialogMailing( "popup-std" ); } );
  //otevření mailing formuláře opuštěním stránky
  /*$(document).mousemove(function(e) {
    if(e.pageY <= 5)
    {
      openDialogMailing( "popup-exit" );
    }
  });*/

  $('form#emailMailing').submit( function(e)
  {
    if ( $(this).hasClass( 'already-submitted' ) )
    {
      e.preventDefault();
      return false;
    }
    else
    {
      if(!KontrolaFormularMailing())
      {
         return false;
      }
      $(this).addClass( 'already-submitted' );
      return true;
    }
  });

});

function whenReady(video, callback) {
  // HAVE_CURRENT_DATA (2) = video má stažený aktuální snímek, lze bezpečně přehrát
  if (video.readyState >= 2) {
    callback();
    return;
  }
  const onReady = () => {
    video.removeEventListener('loadeddata', onReady);
    video.removeEventListener('video-source-ready', onReady);
    callback();
  };
  video.addEventListener('loadeddata', onReady, { once: true });
  video.addEventListener('video-source-ready', onReady, { once: true }); // pojistka pro větev bez data-src
}

/*function whenReady(video, callback) {
    // Video je připravené, pokud už nemá source s nedosazeným data-src
    const pendingSource = video.querySelector('source[data-src]');
    if (!pendingSource) {
      callback();
    } else {
      video.addEventListener('video-source-ready', callback, {once: true});
    }
}*/

/**
 * Inicializuje lightGallery na prvku fotogalerie (galerie typu 4). Volá se při načtení stránky i pro dynamicky vložené fotogalerie.
 * @param {HTMLElement} galerieElement prvek .fotogalerie
 * @returns {void}
 */
function initGalerie( galerieElement )
{
  var maZoomClass = galerieElement.classList.contains('galerie-priblizeni');
  
  var instance = lightGallery(galerieElement, {
      selector: '.fotka_obr a:not([data-lg-ignore]), .fotka a:not([data-lg-ignore]), .fotka_zaklad:not([data-lg-ignore]), .slider_u_reference a:not([data-lg-ignore])',
      thumbnail: true,
      plugins: [lgZoom, lgThumbnail, lgFullscreen, lgAutoplay, /*lgRotate*/, /*lgShare, */lgVideo],
      getCaptionFromTitleOrAlt: false,

      controls: true,
      keyPress: true,
      trapFocus: true,
      hideScrollbar: true, 
      download: false,
      loop: true,
      hideBarsDelay: 0,
       
      toggleThumb: true,
      zoom: true, 
      fullScreen: true,
      autoplay: true, 
      slideShowAutoplay: false,
      slideShowInterval: 2000,
      progressBar: true,
      forceSlideShowAutoplay: false,
      
      addClass: maZoomClass ? 'galerie-priblizeni' : '',
      
      mobileSettings: {
          controls: true,
          showCloseIcon: true,
      }

      //share: true,
      //rotate: true,
      //rotateLeft: true,
      //rotateRight: true,
      //flipHorizontal: true,
      //flipVertical: true,
  });
   
  /*function zoomPokudKonfigurator(galerieElement, instance) {
      var aktualniIndex = instance.index;

      var aktualniPrvek = $(galerieElement)
          .find('.fotka_obr a:not([data-lg-ignore]), .fotka a:not([data-lg-ignore]), .fotka_zaklad:not([data-lg-ignore]), .slider_u_reference a:not([data-lg-ignore])')
          .eq(aktualniIndex);

      if (
          aktualniPrvek.hasClass('konfigurator') ||
          aktualniPrvek.closest('.konfigurator').length
      ) {
          setTimeout(function () {
              document.querySelector('.lg-zoom-in')?.click();
          }, 300);
      }
  }

  galerieElement.addEventListener('lgAfterOpen', function () {
      zoomPokudKonfigurator(galerieElement, instance);
  });

  galerieElement.addEventListener('lgAfterSlide', function () {
      zoomPokudKonfigurator(galerieElement, instance);
  });*/
  /*automatický zoom na první fotku galerie
  galerieElement.addEventListener('lgAfterOpen', function () { 
    if( window.matchMedia('(max-width: 992px)').matches ) return ;
    var aktualniIndex = instance.index;
    var aktualniPrvek = $(galerieElement).find('.fotka_obr a:not([data-lg-ignore]), .fotka a:not([data-lg-ignore]), .fotka_zaklad:not([data-lg-ignore]), .slider_u_reference a:not([data-lg-ignore])').eq(aktualniIndex);
    if (aktualniPrvek.hasClass('konfigurator') || aktualniPrvek.closest('.konfigurator').length) { 
      setTimeout(function () {
        document.querySelector('.lg-zoom-in')?.click();
      }, 500);
    }
  });*/ 
  
  $(galerieElement).data('lgInstance', instance);
}

function refreshGalerie(idGalerie) {
    var $galerie = $('.fotogalerie_' + idGalerie);
    var instance = $galerie.data('lgInstance');

    if (instance) {
        instance.refresh();
    }
}

var scrollTopOpen = 0;
var dialogScrollLocked = false;

function openDialogScroll()
{
  if (dialogScrollLocked) return;
  dialogScrollLocked = true;
  
  scrollTopOpen = $(window).scrollTop();
  $('body').css({
    position: 'fixed',
    top: -scrollTopOpen + 'px',
    width: '100%'
  });
}

function closeDialogScroll()
{
  if (!dialogScrollLocked) return;
  dialogScrollLocked = false;
  
  var y = scrollTopOpen;

  // volitelné: dočasně vypnout smooth scroll, aby to necukalo animací
  var html = document.documentElement;
  var prevScrollBehavior = html.style.scrollBehavior;
  html.style.scrollBehavior = 'auto';

  // 1) nejdřív odfixovat body
  $('body').css({ position: '', top: '', width: '' });

  // 2) scroll vrátit až v dalším snímku (zabrání "bliknutí")
  requestAnimationFrame(function () {
    window.scrollTo(0, y);

    // 3) vrátit původní scroll-behavior
    html.style.scrollBehavior = prevScrollBehavior;
  });
}

function openDialogMailing( zdroj=1 )
{
  if( $( "#mailing_dialog" ).length > 0 )
  {
    //$(document).scrollTop();
    var windowWidth = $(window).width();
    $( "#mailing_dialog input[name=zdroj]" ).val( zdroj );
    $( "#mailing_dialog" ).dialog({
      resizable: true,
      width: ( windowWidth <= 600 ? windowWidth - 50 : "60%" ),
      modal: true,
      closeText: "",
      dialogClass: "dialog_web",
      /*open: function() {
        openDialogScroll();
      },
      close: function() {
        closeDialogScroll();
      },*/
      beforeClose: function () {
        $('body').css('overflow', '');
      },
      buttons: {
        "Zavřít": function () {
          $('body').css('overflow', '');
          $(this).dialog("close");
        }
      }
    });
  }
}

function KontrolaFormularMailing()
{
  var chyby = 0;
  $('#emailMailing .chyba_req').hide();
  $.each( $('#emailMailing .req'), function( key, value )
  {
     $( value ).removeAttr('style');
    if($( value ).attr('name') === 'email')
    {
      if( $( value ).val().match(/^[-!#$%&\'*+\\./0-9=?A-Z^_`a-z{|}~]+@[-!#$%&\'*+\\/0-9=?A-Z^_`a-z{|}~]+\.[-!#$%&\'*+\\./0-9=?A-Z^_`a-z{|}~]+$/))
      {
        $( value ).removeAttr('style');
      }
      else
      {
        $( value ).css('border-color','red');
        $( value ).parent().parent().find('.chyba_req').show();
        chyby++;
      }
    }
    else if($( value ).attr('name') === 'jmeno')
    {
      if( $( value ).val().length >= 0 && $( value ).val().length <= 50 )
      {
        $( value ).removeAttr('style');
      }
      else
      {
        $( value ).css('border-color','red');
        $( value ).parent().parent().find('.chyba_req').show();
        chyby++;
      }
    }
    else if($( value ).attr('name') === 'simpleCaptchaRes')
    {
      if($( value ).val().length > 0)
      {
        $( value ).removeAttr('style');
      }
      else
      {
        $( value ).css('border-color','red');
        chyby++;
      }
    }
  });
  if(chyby === 0) return true;
  else return false;
}

function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
        rect.left >= 0 &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

/**
 * lepší je tato funkce pro ověření viewportu
 * @param {type} posunSpodni - o kolik to kontroluje méně spodní okraj - abych měl jistotu viditelnosti
 * @returns {Boolean}
 */
$.fn.isInViewport_new = function( posunSpodni=0 ) {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height() - posunSpodni;

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

 // Update the count down every 1 second
  var x = setInterval(function() {
      $(".js_kosik_rez").each(function () {

       var rezervace_id = $(this).val();
       if($('.js_kosik_rezervace_odpocet_'+rezervace_id).val())
       {
         var countDownDate = new Date($('.js_kosik_rezervace_odpocet_'+rezervace_id).val()).getTime();

         var now = new Date().getTime();

         var distance = countDownDate - now;

         var days = Math.floor(distance / (1000 * 60 * 60 * 24));
         var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
         var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
         var seconds = Math.floor((distance % (1000 * 60)) / 1000);

         $('.js_rezervace_vypis_'+rezervace_id).empty();
         $('.js_rezervace_vypis_'+rezervace_id).append($("#js_kosik_rezervace_text").val() +' '+ minutes + "m " + seconds + "s ");


         if (distance < 0) {

           $('.js_rezervace_vypis_'+rezervace_id).empty();
           $('.js_rezervace_vypis_'+rezervace_id).append($("#js_kosik_rezervace_text_konec").val());

           if(rezervace_id)
           {
             $('.js_kosik_rezervace_odpocet_'+rezervace_id).remove();
             $('.js_kosik_rezervace_id_'+rezervace_id).remove();
             $.ajax({
                    url: '/rsadmin/_funkce/eshop_dostupnost_produkty.php',
                    type: "GET",
                    dataType: "html",
                    cache: false,
                    async: false,
                    data: { typ: 9, id_rez: rezervace_id},
                    success: function (aData) {

                    }
              });
           }
         }
       }
      });

  }, 1000);

